class RecorderWorkletNode extends AudioWorkletNode {
    constructor(context) {
        super(context, 'recorder-processor');
        this.counter_ = 0;
        this.port.onmessage = this.handleMessage_.bind(this);
    }

    record() {
        this.port.postMessage({
            message: 'record', 
            contextTimestamp: this.context.currentTime,
        });
    }

    stop() {
        this.port.postMessage({
            message: 'stop', 
            contextTimestamp: this.context.currentTime,
        });
    }

    async getBuffer() {
        this.buffer = undefined;
        this.port.postMessage({
            message: 'get_buffer', 
            contextTimestamp: this.context.currentTime,
        });
        
        while (this.buffer === undefined) {
            await this.sleep(10);
        }
        
        return this.buffer;
    }

    async sleep(time) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

    handleMessage_(event) {
        console.log('[Node:handleMessage_] ' + event.data.message +
                          ' (' + event.data.contextTimestamp + ')');
        let msg = event.data.message;
        if (msg.type === 'get_buffer') {
            this.buffer = msg.data;
        }
    }
}

export default RecorderWorkletNode;
